module.exports.LIST_CUSTOMER_ACCESS = 'LIST_CUSTOMER_ACCESS';
module.exports.ERROR_CUSTOMER_ACCESS = 'ERROR_CUSTOMER_ACCESS';

